import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Terms of Use</h1>
            <p className="text-sm text-gray-600">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none space-y-8">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using the BRX Resource website (brxresource.com), you agree to be bound by these Terms of Use. If you do not agree to these terms, you should not use this website.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Website Purpose</h2>
            <p className="text-gray-700 leading-relaxed">
              This website provides general information about BRX Resource and the services we may provide. It is intended for informational purposes only and does not constitute:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>An offer to provide services</li>
              <li>A commitment, guarantee, or assurance of any kind</li>
              <li>Professional advice or recommendations</li>
              <li>A binding agreement or contract</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. No Reliance</h2>
            <p className="text-gray-700 leading-relaxed">
              Information provided on this website is general in nature. You should not rely on this information as the basis for making business, legal, or other decisions. All services are provided only pursuant to written agreements that set forth specific terms, conditions, and approvals.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. No Representations or Warranties</h2>
            <p className="text-gray-700 leading-relaxed">
              This website and all content are provided "as is" without warranty of any kind, either express or implied, including but not limited to:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>Warranties of merchantability or fitness for a particular purpose</li>
              <li>Warranties regarding accuracy, completeness, or timeliness of information</li>
              <li>Warranties of uninterrupted or error-free access</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              To the fullest extent permitted by law, BRX Resource shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>Use of or inability to use this website</li>
              <li>Reliance on information contained on this website</li>
              <li>Errors, omissions, or inaccuracies in website content</li>
              <li>Unauthorized access to or alteration of your transmissions or data</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Engagement Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              Any actual engagement for services requires:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>A separate written agreement signed by authorized representatives</li>
              <li>Documented approvals and written confirmations</li>
              <li>Mutually agreed commercial terms</li>
              <li>Compliance with all applicable statutory and regulatory requirements</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              No verbal or informal communication constitutes a binding commitment.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              All content on this website, including text, graphics, logos, and design, is the property of BRX Resource or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without express written permission.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. User Conduct</h2>
            <p className="text-gray-700 leading-relaxed">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
              <li>Use this website for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any portion of the website</li>
              <li>Interfere with or disrupt the website or servers</li>
              <li>Transmit any harmful code, viruses, or malicious software</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Links to Third-Party Sites</h2>
            <p className="text-gray-700 leading-relaxed">
              This website may contain links to third-party websites. We do not control or endorse these sites and are not responsible for their content, privacy practices, or terms of use.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law and Jurisdiction</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms of Use shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms or use of this website shall be subject to the exclusive jurisdiction of courts located in Noida, Uttar Pradesh, India.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these Terms of Use at any time. Changes will be posted on this page with an updated "Last Updated" date. Your continued use of the website after changes constitutes acceptance of the modified terms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have questions about these Terms of Use, please contact us at:
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Email: info@brxresource.com<br />
              Location: Noida, Uttar Pradesh, India
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-blue-900 hover:text-blue-800 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUse;